import { AbstractObservationPlotBaton } from "../ObservationPlotFactory/AbstractObservationPlotBaton"
import { id_accessor } from "../../../../components/shared_components_registration"

export class ObservationPlotBaton extends AbstractObservationPlotBaton {
  constructor(config) {
    super()

    this.config = config
    this.dataKey = "observations"
    this.y1obs = (config[this.dataKey] || []).filter((obs) => !obs.axis2 && !obs.disabled)
    this.y2obs = (config[this.dataKey] || []).filter((obs) => obs.axis2 && !obs.disabled)
  }

  getPlotProps(run, viewerState) {
    return {
      id: run[id_accessor], // Unique to multirun plot factory
      combinedActions: run.getCombinedActions
        ? run.getCombinedActions(run).map((a) => ({ ...a, name: run.name, reactor: run.reactor }))
        : [], // Unique to multirun plot factory
      observationAccessor: run.observationAccessor,
      observationTypes: run.observationTypes,
      observationTypesFlat: run.observationTypesFlat,
      queryTags: viewerState.queryTags,
      sample_types: run.sample_types || [],
    }
  }
}
